import { render, staticRenderFns } from "./sizeConfig.vue?vue&type=template&id=a3a74154&"
import script from "./sizeConfig.vue?vue&type=script&lang=js&"
export * from "./sizeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports